// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shadow-take-photo-itineraries[data-v-dedb9898]{-webkit-box-shadow:0 4px 10px 0 rgba(0,0,0,.3019607843);box-shadow:0 4px 10px 0 rgba(0,0,0,.3019607843)}[data-v-dedb9898] .section-table{display:grid;border:1px solid #e6e6e6;border-radius:10px;overflow:hidden}[data-v-dedb9898] .section-table.pax-table-template-columns{grid-template-columns:6% 44% 50%}[data-v-dedb9898] .section-table .border-t{border-top:1px solid #e6e6e6}", ""]);
// Exports
module.exports = exports;
